import {
  dropdownCommandItem,
  dropdownContentBase,
  dropdownFormWrapper,
  dropdownTriggerBase,
  dropdownTriggerInvalid,
} from '@avanta/shared/components/ui/styles/dropdown';
import { cn } from '@avanta/shared/utils/cn';

export const comboboxWrapper = dropdownFormWrapper;

export const comboboxTrigger = cn(
  dropdownTriggerBase,
  'relative w-full px-4 py-2 pr-10 data-has-left-icon:pl-10',
  'data-[has-value=false]:text-gray-400',
  dropdownTriggerInvalid
);

export const comboboxContent = cn(
  dropdownContentBase,
  'origin-[--radix-popover-content-transform-origin] p-0',
  'w-full min-w-(--radix-popover-trigger-width)'
);

export const comboboxItem = dropdownCommandItem;
